import React from "react";
import CdnImage from "./CdnImage";

type NetworkImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallback?: boolean;
};

export default function NetworkImage(props: NetworkImageProps) {
  return (
    <CdnImage
      {...props}
      cdnParams={{
        format: "webp",
      }}
    />
  );
}
